import * as Mui from "@mui/material";
import * as MuiIcons from "@mui/icons-material";
import { customTheme } from "../../../../../config/theme/MuiTheme";
import useOperationTranslation from "../../../hooks/useOperationTranslation";

interface Props {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
  title: string;
  content: string;
  deleteBtnText: string;
}

const DeleteConfirmation = (props: Props) => {
  const t = useOperationTranslation();

  const onDelete = () => {
    props.onClose();
    props.onDelete();
  }

  return (
    <Mui.Dialog open={props.open} onClose={props.onClose}>
      <Mui.DialogTitle>
        <Mui.Grid container wrap="nowrap">
          <Mui.Grid item xs="auto" color={customTheme.palette.accent.main}>
            <Mui.Stack direction="row" gap="16px">
              <MuiIcons.Info />
              <Mui.Typography variant="h6">
                {props.title}
              </Mui.Typography>
            </Mui.Stack>
          </Mui.Grid>

          <Mui.Grid item xs="auto" marginLeft="auto">
            <Mui.IconButton onClick={props.onClose}>
              <MuiIcons.Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>

      <Mui.DialogContent>
        <Mui.Typography whiteSpace="pre-line">
          {props.content}
        </Mui.Typography>
      </Mui.DialogContent>

      <Mui.DialogActions>
        <Mui.Stack direction="row" justifyContent="end" gap="16px">
          <Mui.Button variant="outlined" onClick={props.onClose}>
            {t("vehicleEquipmentAssociation.dialogs.delete.actions.cancel")}
          </Mui.Button>

          <Mui.Button onClick={onDelete}>
            {props.deleteBtnText}
          </Mui.Button>
        </Mui.Stack>
      </Mui.DialogActions>
    </Mui.Dialog>
  )
}

export default DeleteConfirmation;